import {
  Beaker,
  Building2,
  Calendar,
  CreditCard,
  Mail,
  FileText,
  FolderOpen,
  Home,
  Image as ImageIcon,
  Link,
  // Megaphone,
  Menu,
  Radar,
  // Shield,
  Tag,
  // UserPlus,
  Users,
} from 'lucide-react';
import type { NavSection } from './Sidebar.types';

export const getNavSections = (): NavSection[] => {
  const basePath = '';

  const sections: NavSection[] = [
    {
      title: '',
      items: [
        {
          icon: Home,
          label: 'Dashboard',
          path: `${basePath}/dashboard`,
        },
      ],
    },
    {
      title: 'Content',
      items: [
        {
          icon: FileText,
          label: 'Articles',
          path: `${basePath}/articles`,
        },
        {
          icon: Menu,
          label: 'Insights',
          path: `${basePath}/insights`,
        },
        {
          icon: Tag,
          label: 'Brands',
          path: `${basePath}/brands`,
        },
        {
          icon: Building2,
          label: 'Suppliers',
          path: `${basePath}/suppliers`,
        },
        {
          icon: Radar,
          label: 'Supplier Scans',
          path: `${basePath}/supplier-scans`,
        },
        {
          icon: Beaker,
          label: 'Ingredients',
          path: `${basePath}/ingredients`,
        },
        {
          icon: FolderOpen,
          label: 'Categories',
          path: `${basePath}/categories`,
        },
        {
          icon: ImageIcon,
          label: 'Media',
          path: `${basePath}/media`,
        },
      ],
    },
    {
      title: 'Users',
      items: [
        {
          icon: Users,
          label: 'User List',
          path: `${basePath}/users`,
        },
        // {
        //   icon: UserPlus,
        //   label: 'Pending Registrations',
        //   path: `${basePath}/users/pending`,
        //   badge: pendingCount,
        // },
        // {
        //   icon: Shield,
        //   label: 'Roles & Permissions',
        //   path: `${basePath}/users/roles`,
        // },
      ],
    },
    {
      title: 'Billing',
      items: [
        {
          icon: CreditCard,
          label: 'Subscriptions',
          path: `${basePath}/subscriptions`,
        },
        {
          icon: Mail,
          label: 'Email Logs',
          path: `${basePath}/email-logs`,
        },
      ],
    },
    {
      title: 'Marketing',
      items: [
        // {
        //   icon: Megaphone,
        //   label: 'Advertorials',
        //   path: `${basePath}/advertorials`,
        // },
        {
          icon: Link,
          label: 'Affiliate Links',
          path: `${basePath}/affiliate-links`,
        },
        {
          icon: Calendar,
          label: 'Events',
          path: `${basePath}/events`,
        },
      ],
    },
    // {
    //   title: '',
    //   items: [
    //     {
    //       icon: BarChart3,
    //       label: 'Analytics',
    //       path: `${basePath}/analytics`,
    //     },
    //   ],
    // },
  ];

  return sections;
};
